import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/reducer";
import idSlice from "./asset/itemReducer";

export const REDUCER_TYPES = {
  AUTH: "auth",
};

const store = configureStore({
  reducer: {
    [REDUCER_TYPES.AUTH]: authReducer,
    DeviceId: idSlice,
  },
});

export default store;
